var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox relative" },
    [
      _c(
        "el-card",
        {
          staticClass: "box-card dataBox",
          attrs: { "body-style": { padding: "0 20px 20px" } },
        },
        [
          _c(
            "el-tabs",
            {
              staticClass: "list-tabs",
              model: {
                value: _vm.activeName,
                callback: function ($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName",
              },
            },
            [
              _c("el-tab-pane", {
                attrs: { label: "上门服务流程", name: "1" },
              }),
              _c("el-tab-pane", { attrs: { label: "服务区域", name: "2" } }),
            ],
            1
          ),
          _vm.activeName == 1
            ? _c(
                "el-table",
                {
                  staticClass: "mt10 width100",
                  attrs: { data: _vm.tableData },
                },
                [
                  _c("el-table-column", {
                    attrs: { prop: "name", label: "节点名称", width: "180" },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "status", label: "状态", width: "200" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm.checkPermi([
                                "admin:merchant:reservation:to:home:edit",
                              ])
                                ? _c(
                                    "div",
                                    [
                                      scope.row.status
                                        ? _c("el-switch", {
                                            attrs: {
                                              disabled: "",
                                              "active-value": true,
                                              "inactive-value": false,
                                              "active-text": "开启",
                                              "inactive-text": "关闭",
                                            },
                                            model: {
                                              value: scope.row.status,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  scope.row,
                                                  "status",
                                                  $$v
                                                )
                                              },
                                              expression: "scope.row.status",
                                            },
                                          })
                                        : _c("el-switch", {
                                            attrs: {
                                              "active-value": true,
                                              "inactive-value": false,
                                              "active-text": "开启",
                                              "inactive-text": "关闭",
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.statusChange(
                                                  scope.row
                                                )
                                              },
                                            },
                                            model: {
                                              value: _vm.form[scope.row.key],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  scope.row.key,
                                                  $$v
                                                )
                                              },
                                              expression: "form[scope.row.key]",
                                            },
                                          }),
                                    ],
                                    1
                                  )
                                : _c("div", [
                                    _vm._v(
                                      _vm._s(scope.row.status ? "开启" : "关闭")
                                    ),
                                  ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1828288275
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "info", label: "说明" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("div", {
                                domProps: { innerHTML: _vm._s(scope.row.info) },
                              }),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3794416250
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "address", label: "操作", width: "100" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.action &&
                              _vm.checkPermi([
                                "admin:merchant:reservation:to:home:edit",
                              ])
                                ? _c(
                                    "a",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.open(scope.row)
                                        },
                                      },
                                    },
                                    [_vm._v(_vm._s(scope.row.action))]
                                  )
                                : _vm._e(),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      756783750
                    ),
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.activeName == 2
            ? _c(
                "div",
                { staticClass: "width100" },
                [
                  _c("draw-geometry-map", {
                    on: { getServiceAreaRange: _vm.getServiceAreaRange },
                    model: {
                      value: _vm.form,
                      callback: function ($$v) {
                        _vm.form = $$v
                      },
                      expression: "form",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "管理表单设置",
            visible: _vm.clockVisible,
            width: "600px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.clockVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "80px",
              },
            },
            [
              _vm.type === 1
                ? [
                    _c(
                      "el-form-item",
                      { attrs: { label: "打卡限制：" } },
                      [
                        _c(
                          "el-radio-group",
                          {
                            on: { change: _vm.typeChange },
                            model: {
                              value: _vm.form.clockInAddressSwitch,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "clockInAddressSwitch", $$v)
                              },
                              expression: "form.clockInAddressSwitch",
                            },
                          },
                          [
                            _c("el-radio", { attrs: { label: true } }, [
                              _vm._v("服务范围内打卡"),
                            ]),
                            _c("el-radio", { attrs: { label: false } }, [
                              _vm._v("不限制打卡地址"),
                            ]),
                          ],
                          1
                        ),
                        _c("div", { staticClass: "from-tips" }, [
                          _vm._v("未配置地图时，请选择不限制打卡地址"),
                        ]),
                      ],
                      1
                    ),
                    _vm.form.clockInAddressSwitch
                      ? _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "打卡范围：",
                              prop: "clockInDistance",
                            },
                          },
                          [
                            _c("el-input-number", {
                              staticStyle: { width: "48%" },
                              attrs: { size: "small", type: "number", min: 1 },
                              model: {
                                value: _vm.form.clockInDistance,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "clockInDistance",
                                    _vm._n($$v)
                                  )
                                },
                                expression: "form.clockInDistance",
                              },
                            }),
                            _c("span", { staticClass: "from-tips ml10" }, [
                              _vm._v("米"),
                            ]),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "el-form-item",
                      { attrs: { label: "打卡要求：" } },
                      [
                        _c(
                          "el-radio-group",
                          {
                            model: {
                              value: _vm.form.clockInPhotoSwitch,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "clockInPhotoSwitch", $$v)
                              },
                              expression: "form.clockInPhotoSwitch",
                            },
                          },
                          [
                            _c("el-radio", { attrs: { label: true } }, [
                              _vm._v("需要拍照备注"),
                            ]),
                            _c("el-radio", { attrs: { label: false } }, [
                              _vm._v("跳过拍照备注环节"),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
              _vm.type === 2 && _vm.clockVisible
                ? [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "关联表单：",
                          prop: "serviceEvidenceFormId",
                        },
                      },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "57%" },
                            attrs: {
                              placeholder: "请选择关联表单",
                              clearable: "",
                              filterable: "",
                            },
                            model: {
                              value: _vm.form.serviceEvidenceFormId,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "serviceEvidenceFormId", $$v)
                              },
                              expression: "form.serviceEvidenceFormId",
                            },
                          },
                          _vm._l(_vm.systemFormList, function (item, index) {
                            return _c("el-option", {
                              key: index.id,
                              attrs: { value: item.id, label: item.formName },
                            })
                          }),
                          1
                        ),
                        _vm.checkPermi(["merchant:system:form:add"])
                          ? _c(
                              "el-button",
                              {
                                staticClass: "ml15",
                                attrs: { size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handlerCreatFrom(0, "add")
                                  },
                                },
                              },
                              [_vm._v("添加表单")]
                            )
                          : _vm._e(),
                        _vm.checkPermi(["merchant:system:form:add"])
                          ? _c(
                              "el-button",
                              {
                                staticClass: "ml15",
                                attrs: { size: "small" },
                                on: { click: _vm.getFormList },
                              },
                              [_vm._v("刷新")]
                            )
                          : _vm._e(),
                        _c("div", { staticClass: "from-tips mb5" }, [
                          _vm._v("服务人员结束服务之前，必须提交此表单内容。"),
                        ]),
                        _vm.form.serviceEvidenceFormId
                          ? _c("div", { staticClass: "item" }, [
                              _c(
                                "div",
                                { staticClass: "acea-row row-middle" },
                                [
                                  _c("div", [
                                    _c("iframe", {
                                      staticStyle: {
                                        width: "350px",
                                        height: "500px",
                                      },
                                      attrs: {
                                        src:
                                          _vm.$selfUtil.getFrontDomainUrl() +
                                          "/pages/goods/systemIframe/index?id=" +
                                          _vm.form.serviceEvidenceFormId,
                                        frameborder: "0",
                                      },
                                    }),
                                  ]),
                                ]
                              ),
                            ])
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
            ],
            2
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.handleSubmit },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }